import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs';
import { AppUtilityService } from '../services/app-utility.service';
/**
 * Route guard that checks if the user is authenticated before allowing navigation.
 * This guard uses the AppUtilityService to check the authentication state of the user.
 * If the user is not authenticated, they are redirected to the login page.
 */
export const authGuard: CanActivateFn = () => {
  const appUtilityService = inject(AppUtilityService);
  const router = inject(Router);

  return appUtilityService.isAuthenticated().pipe(
    take(1),
    map(isAuthenticated => {
      if (!isAuthenticated) {
        return router.createUrlTree(['/login']);
      }
      return true;
    })
  );
}
